// extracted by mini-css-extract-plugin
export default {"btns":"confirmation-modal_btns__emiMA"};